import { renderSlot as _renderSlot } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _renderSlot(_ctx.$slots, "default", {
    handleSubmit: _ctx.handleSubmitSlot,
    invalid: _ctx.invalid,
    validate: _ctx.validateSlot,
    reset: _ctx.resetSlot
  })
}